// use-navigation-intent.ts
import { create } from 'zustand';

type NavigationState = {
  redirectTo: string | null;
  setRedirectTo: (path: string) => void;
  clearRedirectTo: () => void;
};

export const useNavigationState = create<NavigationState>((set) => ({
  redirectTo: null,
  setRedirectTo: (path) => set({ redirectTo: path }),
  clearRedirectTo: () => set({ redirectTo: null }),
}));
